module.exports = __webpack_public_path__ + "img/logo-v_animated.dd7da144.svg";